import { gql } from 'apollo-angular';

const COMMITTEE_ITEM_FIELDS = gql`
  fragment CommitteeItemFields on CommitteeItem {
    id
    name
    resolution
    created
    modified
    is_post_closing
    is_condition
    project_id
    committee_approval_type_id
    related_approval_type_id
    cleared
    relatedApprovalType {
      id
      name
    }
    relatedApprovalTypes {
      id
      name
      committeeItemRelationId
    }
    creator {
      id
      person {
        name
      }
    }
    updater {
      id
      person {
        name
      }
    }
    is_legal_note
    milestone_id
  }
`;

const CREATE_COMMITTEE_ITEM = gql`
  ${COMMITTEE_ITEM_FIELDS}
  mutation createCommitteeItem($input: CommitteeItemInput) {
    item: createCommitteeItem(input: $input) {
      ...CommitteeItemFields
    }
  }
`;
const UPDATE_COMMITTEE_ITEM = gql`
  ${COMMITTEE_ITEM_FIELDS}
  mutation updateCommitteeItem($id: ID!, $input: CommitteeItemInput) {
    item: updateCommitteeItem(id: $id, input: $input) {
      ...CommitteeItemFields
    }
  }
`;

const DELETE_COMMITTEE_ITEM = gql`
  mutation deleteCommitteeItem($id: ID!) {
    item: deleteCommitteeItem(id: $id) {
      id
    }
  }
`;

const CREATE_COMMITTEE_ITEM_RELATION = gql`
    mutation createCommitteeItemRelation($committee_item_id: ID!, $related_approval_type_id:ID!){
      item: createCommitteeItemRelation(committee_item_id: $committee_item_id, related_approval_type_id: $related_approval_type_id){
        id
      }
    }
`

const DELETE_COMMITTEE_ITEM_RELATION = gql`
    mutation deleteCommitteeItemRelation($id:ID!){
      item: deleteCommitteeItemRelation(id:$id){
        id
      }
    }
`

export default {
  CREATE_COMMITTEE_ITEM,
  UPDATE_COMMITTEE_ITEM,
  DELETE_COMMITTEE_ITEM,
  COMMITTEE_ITEM_FIELDS,
  DELETE_COMMITTEE_ITEM_RELATION,
  CREATE_COMMITTEE_ITEM_RELATION
};
